module.exports = __webpack_public_path__ + "static/media/wwhf.d3b8e4fe.svg";